module.exports = __webpack_public_path__ + "img/top_bg5.f2c51e70.png";